import React from "react";
import aiImage from "../../../assets/webdesignMain.jpg";
import strategyImage from "../../../assets/webdesign.jpg";
import webdev from "../../../assets/webdev.jpeg";

export default function WebsiteDesign() {
  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section className="relative h-[60vh] sm:h-[70vh] md:h-[800px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={aiImage}
            alt="Website Design & Development"
            className="w-full h-full object-cover sm:object-contain md:object-cover"
          />
          <div className="absolute inset-0 bg-black/60"></div>
        </div>
        <div className="relative z-10 text-center text-white px-4 sm:px-6">
          <h1 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-bold mb-4 leading-tight">
            Website Design & Development
          </h1>
          <p className="text-sm sm:text-lg md:text-xl lg:text-2xl max-w-3xl mx-auto leading-relaxed">
            Craft UX-rich, high-performance websites integrated with analytics and automation
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-8 sm:py-12 md:py-16 px-4 sm:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-center">
            {/* Image - Left Side */}
            <div className="flex-1 w-full">
              <img
                src={strategyImage}
                alt="Website Design & Development"
                className="w-full h-64 sm:h-80 md:h-96 object-cover rounded-lg shadow-lg"
              />
            </div>

            {/* Content - Right Side */}
            <div className="flex-1 w-full">
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold mb-4 sm:mb-6 text-pink-600 text-center lg:text-left">
                Website Design & Development
              </h2>
              <p className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6 text-center lg:text-left">
                Craft UX-rich, high-performance websites integrated with analytics and automation.
              </p>
              <p className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed text-center lg:text-left">
                We create modern, responsive websites that deliver exceptional user experiences while driving business growth through strategic design and development.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Web Design & Development Section */}
      <section className="py-8 sm:py-12 md:py-16 px-4 sm:px-6 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-center">
            {/* Content - Left Side */}
            <div className="flex-1 w-full">
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold mb-6 text-pink-600 text-center lg:text-left">
                Web Design & Development
              </h2>
              <p className="text-sm sm:text-base md:text-lg text-gray-700 text-center lg:text-left mb-6">
                We design custom sites and all programming is done in-house. Functionality and aesthetic appeal are top priority, and all pages are responsive and mobile-optimized across all devices, browsers and operating systems.
              </p>
              <p className="text-sm sm:text-base md:text-lg text-gray-700 text-center lg:text-left">
                What would serve you best: a lead generation machine, an ecommerce powerhouse or a simple 24/7 business card that you can be proud of? No matter your need, we've got the design and development expertise to get the job done.
              </p>
            </div>

            {/* Image - Right Side */}
            <div className="flex-1 w-full">
              <img
                src={webdev}
                alt="Web Design & Development"
                className="w-full h-64 sm:h-80 md:h-96 object-cover rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Comprehensive Web Development Services Section */}
      <section className="py-8 sm:py-12 md:py-16 px-4 sm:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-6 text-pink-600">
              Comprehensive Web Development Services
            </h2>
            <p className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed max-w-4xl mx-auto">
              In the dynamic digital ecosystem, having a robust online presence is indispensable for businesses aiming to thrive. ALIF, a renowned web design company, offers a spectrum of web development services tailored to elevate your digital footprint and propel your business forward. Our expertise encompasses the entire web development lifecycle, from conceptualisation to deployment. Here's a closer look at the services we provide:
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-6">
            {/* Custom Web Design */}
            <div className="bg-white border-2 border-gray-300 p-6 rounded-lg shadow-md hover:shadow-lg hover:bg-pink-50 transition-all duration-300 w-full md:w-[calc(50%-12px)] lg:w-[calc(33.333%-16px)]">
              <h3 className="text-lg font-bold text-pink-600 mb-3">
                Custom Web Design
              </h3>
              <p className="text-sm text-gray-700 leading-relaxed">
                We understand that your website is the digital face of your brand. Our custom web design services focus on creating unique, visually appealing, and brand-aligned websites that capture your essence and engage your audience.
              </p>
            </div>

            {/* E-commerce Solutions */}
            <div className="bg-white border-2 border-gray-300 p-6 rounded-lg shadow-md hover:shadow-lg hover:bg-pink-50 transition-all duration-300 w-full md:w-[calc(50%-12px)] lg:w-[calc(33.333%-16px)]">
              <h3 className="text-lg font-bold text-pink-600 mb-3">
                E-commerce Solutions
              </h3>
              <p className="text-sm text-gray-700 leading-relaxed">
                With e-commerce dominating the retail landscape, we specialise in developing comprehensive e-commerce platforms that offer seamless shopping experiences, from browsing to checkout. Our solutions are designed to boost sales, manage inventory efficiently, and integrate smoothly with payment gateways.
              </p>
            </div>

            {/* Content Management Systems */}
            <div className="bg-white border-2 border-gray-300 p-6 rounded-lg shadow-md hover:shadow-lg hover:bg-pink-50 transition-all duration-300 w-full md:w-[calc(50%-12px)] lg:w-[calc(33.333%-16px)]">
              <h3 className="text-lg font-bold text-pink-600 mb-3">
                Content Management Systems (CMS)
              </h3>
              <p className="text-sm text-gray-700 leading-relaxed">
                We implement robust CMS solutions, including WordPress, Joomla, and Drupal, empowering you with control over your content. These platforms enable easy content updates, ensuring your website remains fresh and relevant.
              </p>
            </div>

            {/* Responsive Web Design */}
            <div className="bg-white border-2 border-gray-300 p-6 rounded-lg shadow-md hover:shadow-lg hover:bg-pink-50 transition-all duration-300 w-full md:w-[calc(50%-12px)] lg:w-[calc(33.333%-16px)]">
              <h3 className="text-lg font-bold text-pink-600 mb-3">
                Responsive Web Design
              </h3>
              <p className="text-sm text-gray-700 leading-relaxed">
                As mobile usage continues to rise, having a responsive website is non-negotiable. We ensure your website looks and functions flawlessly across all devices, providing a consistent user experience that boosts engagement and retention.
              </p>
            </div>

            {/* Website Development */}
            <div className="bg-white border-2 border-gray-300 p-6 rounded-lg shadow-md hover:shadow-lg hover:bg-pink-50 transition-all duration-300 w-full md:w-[calc(50%-12px)] lg:w-[calc(33.333%-16px)]">
              <h3 className="text-lg font-bold text-pink-600 mb-3">
                Website Development
              </h3>
              <p className="text-sm text-gray-700 leading-relaxed">
                Our expertise in website development allows us to understand unique digital challenges and opportunities. We leverage this insight to build websites that not only meet global standards but also cater to the specific needs of various markets.
              </p>
            </div>

            {/* Web Application Development */}
            <div className="bg-white border-2 border-gray-300 p-6 rounded-lg shadow-md hover:shadow-lg hover:bg-pink-50 transition-all duration-300 w-full md:w-[calc(50%-12px)] lg:w-[calc(33.333%-16px)]">
              <h3 className="text-lg font-bold text-pink-600 mb-3">
                Web Application Development
              </h3>
              <p className="text-sm text-gray-700 leading-relaxed">
                Beyond traditional websites, we offer web application development services, creating complex, scalable, and secure web-based applications that streamline business processes and enhance operational efficiency.
              </p>
            </div>

            {/* SEO & Digital Marketing */}
            <div className="bg-white border-2 border-gray-300 p-6 rounded-lg shadow-md hover:shadow-lg hover:bg-pink-50 transition-all duration-300 w-full md:w-[calc(50%-12px)] lg:w-[calc(33.333%-16px)]">
              <h3 className="text-lg font-bold text-pink-600 mb-3">
                SEO & Digital Marketing
              </h3>
              <p className="text-sm text-gray-700 leading-relaxed">
                A great website deserves to be seen. Our comprehensive SEO and digital marketing services ensure your website ranks high in search engine results, increasing visibility and driving organic traffic to your site.
              </p>
            </div>

            {/* Maintenance & Support */}
            <div className="bg-white border-2 border-gray-300 p-6 rounded-lg shadow-md hover:shadow-lg hover:bg-pink-50 transition-all duration-300 w-full md:w-[calc(50%-12px)] lg:w-[calc(33.333%-16px)]">
              <h3 className="text-lg font-bold text-pink-600 mb-3">
                Maintenance & Support
              </h3>
              <p className="text-sm text-gray-700 leading-relaxed">
                Our commitment to your digital success extends beyond launch. We provide ongoing maintenance and support services to keep your website updated, secure, and performing at its peak.
              </p>
              
            </div>
            <div className="max-w-4xl text-left">
            <p className="text-xs sm:text-sm text-gray-600 leading-relaxed mb-4">
              At ALIF, we pride ourselves on being more than just a web development company; we are your partners in digital transformation. Our holistic approach to web development ensures that every aspect of your online presence is crafted to perfection, from the user interface and user experience to backend functionality.
            </p>
            <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
              Ready to transform your online presence with a website that drives results? Contact ALIF, your trusted web designer, and let's create a digital masterpiece that propels your business into the future.
            </p>
          </div>
          </div>
          
          
        </div>
      </section>
    </div>
  );
}